import React from 'react';
import classNames from 'classnames';
export var ListBox = React.forwardRef(function (_a, ref) {
    var children = _a.children, isExpanded = _a.isExpanded;
    return (React.createElement("div", { className: "ffe-searchable-dropdown__list-container" },
        React.createElement("div", { tabIndex: -1, className: classNames('ffe-searchable-dropdown__list', {
                'ffe-searchable-dropdown__list--open': isExpanded,
            }) },
            React.createElement("div", { ref: ref, role: "listbox" }, children))));
});
